export const plots = [
  {
    id: "p1",
    title: "《暗涌》结局深度解析：那封举报信究竟是谁寄的？",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20detective%20evidence%20board%20with%20photos%20and%20red%20strings%2C%20dim%20moody%20lighting%2C%20deep%20red%20accents%2C%20cinematic%20mystery%20press%20aesthetic%2C%20high%20detail&width=800&height=500&seq=hp-plot-01&orientation=landscape",
    date: "2026-10-11",
    summary:
      "从时间线、人物动机到关键道具，逐帧拆解《暗涌》大结局埋下的伏笔，推测第二季可能走向。",
    tags: ["悬疑", "结局解析"],
    workTitle: "暗涌",
    relatedWorkId: "w1",
    content:
      "《暗涌》的大结局以一场没有台词的雨夜收尾，许多观众在弹幕里追问：那封让旧案重启的举报信，究竟是谁寄的？\n\n1. 时间线的暗示\n全剧多次给出时钟特写，从第一集到最后一集，指针都停在同一时刻。这或许不是巧合，而是暗示举报信与某个特定时刻的记忆有关。\n\n2. 人物动机的错位\n沈焱在追查中发现，每个关键人物说的“真相”都只对自己有利。编剧刻意让观众无法完全信任任何一方，这正是悬疑叙事的魅力所在。\n\n3. 关键道具的回扣\n第一集出现的旧钢笔，在最后一集再次出现。若它确实属于已故的旧案负责人，那么举报信的寄出者很可能与那段被封锁的过往直接相关。\n\n综合以上线索，第二季极有可能围绕“谁在替死去的人说话”展开。当然，以上仅为基于现有信息的推测，真正的答案仍要等官方揭晓。",
  },
  {
    id: "p2",
    title: "《霓虹边缘》记忆设定全解析：你以为的你，还是你吗？",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20sci%20fi%20image%20of%20a%20futuristic%20memory%20storage%20device%20with%20warm%20orange%20glow%20in%20a%20dark%20lab%2C%20cinematic%20mystery%20press%20aesthetic%2C%20high%20detail&width=800&height=500&seq=hp-plot-02&orientation=landscape",
    date: "2026-10-09",
    summary:
      "梳理《霓虹边缘》中“记忆租借”的规则体系，解析主角身份反转背后的哲学命题。",
    tags: ["科幻", "设定解析"],
    workTitle: "霓虹边缘",
    relatedWorkId: "w2",
    content:
      "《霓虹边缘》最迷人的地方，在于它把抽象的哲学问题装进了“记忆租借”这一具体设定里。\n\n1. 规则梳理\n影片设定：记忆可以被提取、存储、租借。租借者能短暂获得他人的人生体验，但会被抽取等量的“自身记忆”作为代价。\n\n2. 主角的困境\n主角作为记忆修复师，本应是规则的旁观者，却因为一次委托被卷入其中。当他发现自己的记忆也被人为修改过时，“我是谁”这个问题被彻底引爆。\n\n3. 视觉与主题的呼应\n霓虹与深红的色调不仅是美学选择，更象征记忆的“失真”——越是鲜艳，越可能是被加工过的。\n\n影片最终没有给出标准答案，而是把一个问句留给观众：如果记忆可以被替换，那么构成“你”的，到底是记忆，还是此刻的选择？",
  },
  {
    id: "p3",
    title: "《午夜列车》环形叙事拆解：七个乘客，一场闭环",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20night%20train%20carriage%20interior%20with%20deep%20red%20lights%20and%20empty%20seats%2C%20moody%20cinematic%20press%20aesthetic%2C%20high%20detail&width=800&height=500&seq=hp-plot-03&orientation=landscape",
    date: "2026-10-07",
    summary:
      "把《午夜列车》的叙事顺序重新排列，你会发现结局其实早在开场三分钟就写好了。",
    tags: ["悬疑", "结构解析"],
    workTitle: "午夜列车",
    relatedWorkId: "w7",
    content:
      "《午夜列车》被称为“需要二刷的电影”，原因就在于它的环形叙事结构。\n\n1. 表面顺序 vs 真实顺序\n影片按“车上时间”推进，但真实事件顺序是打乱的。开场三分钟的一段广播，其实对应的是影片结尾的情节。\n\n2. 七个乘客的身份映射\n每位乘客都对应主角人生中的一个阶段或一种遗憾。列车从不停靠，象征着无法回头的记忆旅程。\n\n3. 名字的意义\n广播反复念出的名字，其实是主角曾经用过的化名。所谓“找出谁才是真正的旅人”，本质是主角与自己和解的过程。\n\n理解了这个闭环，再回看影片开头那句台词，你会发现它早已剧透了全部——只是当时我们都不懂。",
  },
  {
    id: "p4",
    title: "《深海回声》里的声音伏笔：静默才是最响的台词",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20underwater%20scene%20with%20cold%20dark%20water%20and%20a%20single%20faint%20red%20light%20beam%2C%20mysterious%20cinematic%20press%20aesthetic%2C%20high%20detail&width=800&height=500&seq=hp-plot-04&orientation=landscape",
    date: "2026-10-05",
    summary:
      "分析《深海回声》中声音与静默的运用，看影片如何用听觉制造持续的心理压迫。",
    tags: ["惊悚", "视听解析"],
    workTitle: "深海回声",
    relatedWorkId: "w5",
    content:
      "《深海回声》是一部“为耳朵而拍”的惊悚片。它的恐怖不来自突然的跳跃惊吓，而来自声音的层层递进。\n\n1. 环境音的铺垫\n从开场起，低频的水压嗡鸣就持续存在，像一只看不见的手按在观众胸口。\n\n2. 静默的运用\n每当队员之间出现信任危机，环境音会被刻意抽离，留下近乎真空的沉默。导演说：“最恐怖的不是声音，而是声音消失之后。”\n\n3. 录音的回扣\n那段被发现的海底录音，在不同时间点被播放了三次，每次听起来都略有不同。这暗示它并非固定录音，而是某种会“回应”的存在。\n\n影片最终没有解释录音的来源，但正是这种留白，让它在结束之后仍在观众脑中回响。",
  },
  {
    id: "p5",
    title: "《城南旧梦》细节全收录：那些藏在镜头里的告别",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20a%20nostalgic%20old%20town%20alley%20at%20golden%20hour%20with%20warm%20sunlight%20and%20soft%20shadows%2C%20tender%20cinematic%20press%20aesthetic&width=800&height=500&seq=hp-plot-05&orientation=landscape",
    date: "2026-10-03",
    summary:
      "重看《城南旧梦》，你会发现每一个空镜、每一次转场，都是一场无声的告别。",
    tags: ["文艺", "细节解析"],
    workTitle: "城南旧梦",
    relatedWorkId: "w4",
    content:
      "《城南旧梦》的动人之处，藏在那些不说话的镜头里。\n\n1. 反复出现的空镜\n老城的巷口出现过五次，每次光影都不同。它像一位沉默的见证者，记录着时间的流逝。\n\n2. 道具的隐喻\n两人的自行车从并排到分开，最后只剩一辆停在门口——这是导演对“告别”最克制的表达。\n\n3. 结尾的留白\n影片结尾没有拥抱也没有台词，只有渐远的脚步声。这恰恰是青春最真实的样子：很多告别，都是在无人知晓时完成的。\n\n四年后重看，这些细节才真正击中人心。",
  },
  {
    id: "p6",
    title: "《罪案笔记》单元案拆解：为什么配角总比凶手更令人难忘",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20noir%20detective%20office%20at%20night%20with%20scattered%20case%20files%20and%20warm%20red%20lamp%20glow%2C%20moody%20cinematic%20press%20aesthetic%2C%20high%20detail&width=800&height=500&seq=hp-plot-06&orientation=landscape",
    date: "2026-10-01",
    summary:
      "梳理《罪案笔记》几个高口碑单元案件，解析编剧如何用配角群像撑起整部剧的情感重量。",
    tags: ["犯罪", "角色解析"],
    workTitle: "罪案笔记",
    relatedWorkId: "w9",
    content:
      "《罪案笔记》虽然以破案为主线，但真正让观众记住的，往往是案件中的普通人。\n\n1. 案件背后的社会切面\n每一个单元案都对应一种现实困境，编剧用案件外壳包裹对人性与社会的观察。\n\n2. 配角的记忆点\n主角破案靠逻辑，而让观众共情的，是那些在案件中被卷入的受害者与证人。他们的选择构成了案件的真正重量。\n\n3. 主线与单元的呼应\n看似独立的单元案，其实都在为最终的主线旧案埋伏笔。当最后一集所有线索汇聚时，前面每一集的意义才被点亮。\n\n这也是该剧能持续获得高口碑的关键。",
  },
];